import React from "react";
import { Container } from "../../containers/Jobs/style";
import { Card, CardDetails } from "../../styles/Cards";
import Cards from "../Cards/Cards";

const SiteArea = ({ data, id }) => {
  const LinkApp = (repository) => {
    window.location.href = repository;
  };

  return (
    <Container>
      {data.map((item, index) => (
        <Cards key={index} url={item.urlImg}>
          <Card onClick={() => LinkApp(item.repository)}>
            <CardDetails>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </CardDetails>
          </Card>
        </Cards>
      ))}
    </Container>
  );
};
export default SiteArea;
